
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jyLMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $dh538 = parcelRequire("dh538");


var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $3AFGg = parcelRequire("3AFGg");


var $2G1lj = parcelRequire("2G1lj");


var $3uEtK = parcelRequire("3uEtK");


var $2j9Nh = parcelRequire("2j9Nh");


var $6Zbgf = parcelRequire("6Zbgf");


var $lD0oL = parcelRequire("lD0oL");


var $gffgQ = parcelRequire("gffgQ");


var $1wWrF = parcelRequire("1wWrF");


var $eGSg6 = parcelRequire("eGSg6");


var $g4VPN = parcelRequire("g4VPN");


var $9uif7 = parcelRequire("9uif7");


var $42oBg = parcelRequire("42oBg");


var $kzLre = parcelRequire("kzLre");


var $15prs = parcelRequire("15prs");


var $4u5NT = parcelRequire("4u5NT");

async function $1bfca8d0e41c7aa7$var$createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, rate: rate, type: type, abortReason: abortReason, routeName: routeName, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, knownSegments: knownSegments, minorInteractions: minorInteractions } = interaction;
    const sanitisedUfoName = (0, $3AFGg.sanitizeUfoName)(ufoName);
    const configRate = (0, $53d5Q.getExtraInteractionRate)(sanitisedUfoName, type);
    if (!(0, $1haRI.default)(configRate)) return null;
    if ((0, $dh538.fg)('platform_ufo_disable_ufo_names_config')) {
        const config = (0, $53d5Q.getConfig)();
        if (config?.disabledUfoNames && config?.disabledUfoNames.includes(sanitisedUfoName)) return null;
    }
    const pageVisibilityAtTTAI = (0, $3uEtK.default)(interaction);
    const isPageLoad = type === 'page_load' || type === 'transition';
    const hasMinorInteractions = minorInteractions !== undefined && minorInteractions.length > 0;
    if (!isPageLoad) // Only create payload for page load or transition
    return null;
    if (hasMinorInteractions && !(0, $dh538.fg)('platform_ufo_send_extra_metrics_on_dirty_vc')) // Not send if aborted by minor interaction, unless feature gate is on
    return null;
    const calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? (0, $2G1lj.getMoreAccuratePageVisibilityUpToTTAI)(interaction) : null;
    const extraTTAI = (0, $lD0oL.default)(interaction) ?? undefined;
    const newUFOName = (0, $3AFGg.sanitizeUfoName)(ufoName);
    const finalVCMetrics = await (0, $gffgQ.default)(interaction, true);
    // Check if VC is clean and has valid metric
    const vcRevisionPayload = finalVCMetrics?.['ufo:vc:rev'];
    const effectiveRevision = (0, $53d5Q.getMostRecentVCRevision)(ufoName) ?? (0, $53d5Q.DEFAULT_TTVC_REVISION);
    const effectiveVCRevisionPayload = vcRevisionPayload?.find(({ revision: revision })=>revision === effectiveRevision);
    const isVCCleanFor3p = effectiveVCRevisionPayload?.clean ?? false;
    const vcAbortReasonFor3p = effectiveVCRevisionPayload?.abortReason ?? undefined;
    const allowDirtyVC = (0, $dh538.fg)('platform_ufo_send_extra_metrics_on_dirty_vc');
    // Always require valid TTAI
    if (extraTTAI === undefined || typeof extraTTAI !== 'number') return null;
    // When feature gate is off, require no errors; when on, allow errors through
    if (interaction.errors.length > 0 && !(0, $dh538.fg)('platform_ufo_send_extra_metrics_on_dirty_vc')) return null;
    if (isVCCleanFor3p) {
        // When VC is clean, require a valid vc90 metric
        if (effectiveVCRevisionPayload?.['metric:vc90'] === undefined || typeof effectiveVCRevisionPayload?.['metric:vc90'] !== 'number') return null;
    } else if (!allowDirtyVC) // When VC is dirty and feature gate is off, preserve existing behavior
    return null;
    // When VC is dirty and feature gate is on, continue to send payload
    // Get normal TTAI & VC90 for last finished interaction (without 3p)
    if (!lastInteractionFinish || lastInteractionFinish?.abortReason || lastInteractionFinish?.errors?.length) return null;
    const normalTTAI = (0, $lD0oL.default)(lastInteractionFinish) ?? undefined;
    const lastInteractionFinishStart = typeof lastInteractionFinish.start === 'number' ? Math.round(lastInteractionFinish.start) : undefined;
    const lastInteractionFinishEnd = typeof lastInteractionFinish.end === 'number' ? Math.round(lastInteractionFinish.end) : undefined;
    let lastInteractionFinishVC90 = null;
    let lastInteractionFinishVCClean = false;
    if (lastInteractionFinishVCResult) {
        const lastInteractionFinishVCRev = lastInteractionFinishVCResult['ufo:vc:rev'];
        const lastInteractionFinishRevision = lastInteractionFinishVCRev?.find(({ revision: revision })=>revision === effectiveRevision);
        if (lastInteractionFinishRevision?.clean) {
            lastInteractionFinishVCClean = true;
            lastInteractionFinishVC90 = lastInteractionFinishRevision['metric:vc90'];
        } else if (!allowDirtyVC) return null;
    } else if (normalTTAI !== undefined && typeof normalTTAI === 'number' && normalTTAI === extraTTAI) {
        // Because TTAI is equal between with and without 3p, we can assume VC90 is also equal
        lastInteractionFinishVC90 = effectiveVCRevisionPayload?.['metric:vc90'] ?? null;
        lastInteractionFinishVCClean = effectiveVCRevisionPayload?.clean ?? false;
    }
    // Helper function to check if labelStack contains third-party type
    const isThirdParty = (labelStack)=>{
        return labelStack?.some((entry)=>'type' in entry && entry.type === 'third-party') ?? false;
    };
    // Pre-filter 3p data
    const filteredData = {
        errors: interaction.errors.filter((error)=>isThirdParty(error.labelStack)),
        spans: [
            ...interaction.spans,
            ...(0, $4u5NT.interactionSpans)
        ].filter((span)=>isThirdParty(span.labelStack)),
        requestInfo: interaction.requestInfo.filter((req)=>isThirdParty(req.labelStack)),
        customTimings: interaction.customTimings.filter((timing)=>isThirdParty(timing.labelStack)),
        apdex: interaction.apdex.filter((apdex)=>isThirdParty(apdex.labelStack)),
        reactProfilerTimings: interaction.reactProfilerTimings.filter((timing)=>isThirdParty(timing.labelStack)),
        customData: interaction.customData.filter((data)=>isThirdParty(data.labelStack)),
        segments: knownSegments.filter((segment)=>isThirdParty(segment.labelStack)),
        marks: interaction.marks.filter((mark)=>isThirdParty(mark.labelStack))
    };
    // Clear atlaskit spans after filtering
    (0, $4u5NT.interactionSpans).length = 0;
    // Detailed payload
    const getDetailedInteractionMetrics = ()=>{
        return {
            errors: filteredData.errors.map(({ labelStack: labelStack, ...others })=>({
                    ...others,
                    labelStack: labelStack && (0, $3AFGg.optimizeLabelStack)(labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type))
                })),
            holdActive: interaction.hold3pActive ? [
                ...interaction.hold3pActive.values()
            ] : [],
            holdInfo: (0, $g4VPN.optimizeHoldInfo)(interaction.hold3pInfo ?? [], start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            spans: (0, $15prs.optimizeSpans)(filteredData.spans, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            requestInfo: (0, $kzLre.optimizeRequestInfo)(filteredData.requestInfo, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            customTimings: (0, $eGSg6.optimizeCustomTimings)(filteredData.customTimings, start)
        };
    };
    const segments3p = !(0, $dh538.fg)('platform_ufo_remove_deprecated_config_fields') && config.killswitchNestedSegments ? [] : filteredData.segments;
    const segmentTree = (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $3AFGg.buildSegmentTree)(segments3p.map((segment)=>segment.labelStack)) : {};
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.interaction-extra-metrics',
                'experience:name': newUFOName,
                interactionMetrics: {
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    rate: // raw interaction metrics
                    rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    end: Math.round(end),
                    start: Math.round(start),
                    'metric:ttai:3p': extraTTAI,
                    ...finalVCMetrics,
                    segments: (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : (0, $3AFGg.getOldSegmentsLabelStack)(segments3p, interaction.type),
                    marks: (0, $9uif7.optimizeMarks)(filteredData.marks, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    apdex: (0, $1wWrF.optimizeApdex)(filteredData.apdex, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    reactProfilerTimings: (0, $42oBg.optimizeReactProfilerTimings)(filteredData.reactProfilerTimings, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    customData: filteredData.customData,
                    ...getDetailedInteractionMetrics()
                },
                vcClean: isVCCleanFor3p,
                ...vcAbortReasonFor3p !== undefined && {
                    vcAbortReason: vcAbortReasonFor3p
                },
                hasMinorInteractions: hasMinorInteractions,
                hasErrors: interaction.errors.length > 0,
                'vc:effective:revision': effectiveRevision,
                lastInteractionFinish: {
                    start: lastInteractionFinishStart,
                    end: lastInteractionFinishEnd,
                    ttai: normalTTAI,
                    vc90: lastInteractionFinishVC90,
                    vcClean: lastInteractionFinishVCClean
                }
            }
        }
    };
    payload.attributes.properties['event:sizeInKb'] = (0, $2j9Nh.default)(payload.attributes.properties);
    return payload;
}
var $1bfca8d0e41c7aa7$export$2e2bcd8739ae039 = $1bfca8d0e41c7aa7$var$createInteractionExtraLogPayload;
module.exports["default"] = $1bfca8d0e41c7aa7$export$2e2bcd8739ae039;

});

parcelRegister("2G1lj", function(module, exports) {

var $3uEtK = parcelRequire("3uEtK");


var $6cRSt = parcelRequire("6cRSt");

function $aa2c48cbfad44fbb$export$97ea55623bd7f1ae(interaction) {
    const old = (0, $3uEtK.default)(interaction);
    const buffered = (0, $6cRSt.getVisibilityStateFromPerformance)(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
module.exports["getMoreAccuratePageVisibilityUpToTTAI"] = $aa2c48cbfad44fbb$export$97ea55623bd7f1ae;

});

parcelRegister("3uEtK", function(module, exports) {

var $jJ2Ec = parcelRequire("jJ2Ec");

function $bde92bd61e8ffee2$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $jJ2Ec.getPageVisibilityState)(start, end);
}
var $bde92bd61e8ffee2$export$2e2bcd8739ae039 = $bde92bd61e8ffee2$var$getPageVisibilityUpToTTAI;
module.exports["default"] = $bde92bd61e8ffee2$export$2e2bcd8739ae039;

});

parcelRegister("6cRSt", function(module, exports) {
function $4731c539677c42e7$export$bcaa23184870682a(stop) {
    try {
        const results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        // @ts-ignore
        return results.reduce((acc = null, { name: name, startTime: startTime })=>{
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch  {
        return null;
    }
}
module.exports["getVisibilityStateFromPerformance"] = $4731c539677c42e7$export$bcaa23184870682a;

});

parcelRegister("2j9Nh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c4b472c260ea0ce$export$2e2bcd8739ae039);
// Reusable TextEncoder instance to avoid creating new instances
const $2c4b472c260ea0ce$var$textEncoder = new TextEncoder();
function $2c4b472c260ea0ce$export$2e2bcd8739ae039(payload) {
    // Early return for null/undefined to avoid unnecessary processing
    if (!payload) return 0;
    // Use the reusable encoder instance
    return Math.round($2c4b472c260ea0ce$var$textEncoder.encode(JSON.stringify(payload)).length / 1024);
}

});

parcelRegister("lD0oL", function(module, exports) {
$parcel$export(module.exports, "default", () => $fead57a0258ca0a5$export$2e2bcd8739ae039);

var $3uEtK = parcelRequire("3uEtK");

function $fead57a0258ca0a5$export$2e2bcd8739ae039(interaction) {
    const { start: start, end: end } = interaction;
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}

});

parcelRegister("gffgQ", function(module, exports) {

var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $4u5NT = parcelRequire("4u5NT");


var $gY4WW = parcelRequire("gY4WW");


var $3uEtK = parcelRequire("3uEtK");


var $657nk = parcelRequire("657nk");

async function $c32879a3fa820297$var$getVCMetrics(interaction, include3p = false, excludeSmartAnswersInSearch = false) {
    const config = (0, $53d5Q.getConfig)();
    if (!config?.vc?.enabled) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition' && interaction.type !== 'press') return {};
    const interactionStatus = (0, $gY4WW.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    const isPageVisible = pageVisibilityUpToTTAI === 'visible';
    const shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && isPageVisible;
    // Use per-interaction VC observer if available, otherwise fall back to global
    const observer = interaction.vcObserver;
    if (!observer) return {};
    const includeRawData = (0, $1haRI.default)((0, $53d5Q.getVCRawDataInteractionRate)(interaction.ufoName, interaction.type));
    const isSSREnabled = interaction.type === 'page_load' && (config?.ssr || config?.vc.ssrWhitelist?.includes(interaction.ufoName));
    const ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: (0, $657nk.default)(config)
    } : null;
    (0, $4u5NT.postInteractionLog).setVCObserverSSRConfig(ssr);
    const tti = interaction.apdex?.[0]?.stopTime;
    const prefix = 'ufo';
    const result = await observer.getVCResult({
        start: interaction.start,
        stop: interaction.end,
        // Use end3p when available to capture raw data observations during 3p holds
        rawDataStopTime: interaction.end3p,
        tti: tti,
        prefix: prefix,
        includeSSRInV3: config.vc?.includeSSRInV3,
        vc: interaction.vc,
        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
        experienceKey: interaction.ufoName,
        interactionId: interaction.id,
        includeSSRRatio: config.vc?.includeSSRRatio,
        ...ssr,
        include3p: include3p,
        excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
        interactionType: interaction.type,
        isPageVisible: isPageVisible,
        includeRawData: includeRawData
    });
    observer.stop(interaction.ufoName);
    if (!include3p) {
        // For Post Interaction, last interaction should be without 3p
        (0, $4u5NT.postInteractionLog).setLastInteractionFinishVCResult(result);
        (0, $4u5NT.interactionExtraMetrics).setLastInteractionFinishVCResult(result);
    }
    const mostRecentVCRevision = (0, $53d5Q.getMostRecentVCRevision)(interaction.ufoName);
    const mostRecentVCRevisionPayload = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (!shouldReportVCMetrics || !mostRecentVCRevisionPayload?.clean) return result;
    return {
        ...result,
        'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
    };
}
var $c32879a3fa820297$export$2e2bcd8739ae039 = $c32879a3fa820297$var$getVCMetrics;
module.exports["default"] = $c32879a3fa820297$export$2e2bcd8739ae039;

});

parcelRegister("gY4WW", function(module, exports) {
function $1435165d93993c3e$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $1435165d93993c3e$export$2e2bcd8739ae039 = $1435165d93993c3e$var$getInteractionStatus;
module.exports["default"] = $1435165d93993c3e$export$2e2bcd8739ae039;

});

parcelRegister("657nk", function(module, exports) {

var $hPcrh = parcelRequire("hPcrh");

function $a8261301e1ba8a2a$var$getSSRDoneTimeValue(config) {
    return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : $hPcrh.getSSRDoneTime();
}
var $a8261301e1ba8a2a$export$2e2bcd8739ae039 = $a8261301e1ba8a2a$var$getSSRDoneTimeValue;
module.exports["default"] = $a8261301e1ba8a2a$export$2e2bcd8739ae039;

});

parcelRegister("1wWrF", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $2abbcc7c844cb6f6$export$efbacb487c03c9c8(apdex, reactUFOVersion) {
    return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
            ...others,
            stopTime: Math.round(stopTime),
            ...labelStack ? {
                labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion)
            } : {}
        }));
}
module.exports["optimizeApdex"] = $2abbcc7c844cb6f6$export$efbacb487c03c9c8;

});

parcelRegister("eGSg6", function(module, exports) {
function $273137eb822d9212$export$967dd9693261321d(customTimings, interactionStart) {
    return customTimings.reduce((result, item)=>{
        Object.keys(item.data).forEach((key)=>{
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}
module.exports["optimizeCustomTimings"] = $273137eb822d9212$export$967dd9693261321d;

});

parcelRegister("g4VPN", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $9539020607f9f8b6$export$b983e6c30f3a8c82(holdInfo, interactionStart, reactUFOVersion) {
    const holdInfoMap = holdInfo.reduce((result, hold)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            const label = (0, $3AFGg.stringifyLabelStackFully)([
                ...labelStack,
                {
                    name: name
                }
            ]);
            const startTime = Math.round(start);
            const endTime = Math.round(end);
            const timing = result.get(label) || {
                labelStack: (0, $3AFGg.optimizeLabelStack)([
                    ...labelStack,
                    {
                        name: name
                    }
                ], reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...holdInfoMap.values()
    ];
}
module.exports["optimizeHoldInfo"] = $9539020607f9f8b6$export$b983e6c30f3a8c82;

});

parcelRegister("9uif7", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $74cf7a9426febbcc$export$4f8106ecc7ec1c7f(marks, reactUFOVersion) {
    return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
            ...others,
            labelStack: labelStack && (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        }));
}
module.exports["optimizeMarks"] = $74cf7a9426febbcc$export$4f8106ecc7ec1c7f;

});

parcelRegister("42oBg", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4u5NT = parcelRequire("4u5NT");


var $3AFGg = parcelRequire("3AFGg");

function $bf991875f8b945fc$export$70a658ddbf644d3a(reactProfilerTimings, interactionStart, reactUFOVersion) {
    const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && startTime >= interactionStart) {
            const label = (0, $3AFGg.stringifyLabelStackFully)(labelStack);
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $4u5NT.segmentUnmountCache).has(label) && (0, $dh538.fg)('platform_ufo_segment_unmount_count')) {
                timing.unmountCount = (0, $4u5NT.segmentUnmountCache).get(label) || 0;
                (0, $4u5NT.segmentUnmountCache).delete(label);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}
module.exports["optimizeReactProfilerTimings"] = $bf991875f8b945fc$export$70a658ddbf644d3a;

});

parcelRegister("kzLre", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $0542f5492cbc074d$export$9b2c740f95fe352d(requestInfo, interactionStart, reactUFOVersion) {
    const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
        const startTime = networkStart ?? start;
        const endTime = networkComplete ?? end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $3AFGg.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}
module.exports["optimizeRequestInfo"] = $0542f5492cbc074d$export$9b2c740f95fe352d;

});

parcelRegister("15prs", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $99ca7b9dbc47ee50$export$e69673407fa1f9ed(spans, interactionStart, reactUFOVersion) {
    const updatedSpans = spans.reduce((result, span)=>{
        const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $3AFGg.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}
module.exports["optimizeSpans"] = $99ca7b9dbc47ee50$export$e69673407fa1f9ed;

});


//# sourceMappingURL=create-interaction-extra-metrics-payload.ec730d2c.js.map
